import { derived } from 'svelte/store';
import { defaultSeoCmsAccess, type SeoCmsAccessSummary } from '$lib/api/modules-access';
import { loadModulesAccess, modulesAccess, modulesAccessState, resetModulesAccess } from './modulesAccess';

export type { SeoCmsAccessSummary } from '$lib/api/modules-access';

export const seoCmsAccess = derived(
  modulesAccess,
  ($modulesAccess): SeoCmsAccessSummary => $modulesAccess?.seoCms ?? defaultSeoCmsAccess
);
export const isLoadingSeoCmsAccess = derived(modulesAccessState, ($state) => $state.status === 'refreshing');

export async function loadSeoCmsAccess(force = false): Promise<void> {
  await loadModulesAccess(force);
}

export function resetSeoCmsAccess(): void {
  resetModulesAccess();
}
